import PropTypes from "prop-types";
import React from "react";
import environment from "web/script/modules/environment";
import CookieBanner from "./cookie-banner";

function CookieBannerVariation({ cookieBanner }) {
    // Process the serializer and variation to show the correct cookie banner
    const defaultCookieBannerProps = {
        cookiePolicyUrl: cookieBanner.cookie_policy_url,
    };

    const bottomBanner = environment.getFeature("mg_cookie_banner_always_at_bottom");

    return cookieBanner.cookie_banner_variation === "bottom_close" || bottomBanner ? (
        <CookieBanner closeButton="button" position="bottom" {...defaultCookieBannerProps} />
    ) : (
        <CookieBanner position="top" closeButton="cross" {...defaultCookieBannerProps} />
    );
}

CookieBannerVariation.propTypes = {
    cookieBanner: PropTypes.shape({
        cookie_policy_url: PropTypes.string.isRequired,
        cookie_banner_variation: PropTypes.oneOf(["bottom_close", "top_cross"]),
    }).isRequired,
};

export default CookieBannerVariation;
